import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const contactAPI = {
  // Submeter formulário de contato
  submitForm: async (formData, formType = 'general') => {
    try {
      const response = await axios.post(`${API}/contact/submit`, formData, {
        params: { form_type: formType }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
      throw error;
    }
  },

  // Obter todas as submissões (para admin)
  getSubmissions: async (status = null, limit = 50) => {
    try {
      const response = await axios.get(`${API}/contact/submissions`, {
        params: { status, limit }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar submissões:', error);
      throw error;
    }
  },

  // Atualizar status de uma submissão (para admin)
  updateStatus: async (formId, status) => {
    try {
      const response = await axios.patch(
        `${API}/contact/submissions/${formId}/status`,
        null,
        { params: { status } }
      );
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      throw error;
    }
  }
};

export default contactAPI;
